<template>
  <Modal
    width="920"
    title="转化类型选择及校验"
    class-name="vertical-center-modal"
    v-model="state"
    :closable="false"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="show"></Spin>
    <div class="c-convert">
      <div class="c-convert-table">
        <dl class="c-table-thead">
          <dt style="width: 40%">账号</dt>
          <dt style="width: 45%">类型</dt>
          <dt style="width: 15%">是否可用</dt>
        </dl>
        <div class="c-convert-body">
          <dl class="item-account">
            <dd v-for="(account, index) of success_d" :key="account.id" :class="{ on: account.index === current }" @click="current = index">
              <span>{{ account.name }}</span>
              <span v-if="typeof account.convert_idx === 'number'" style="color: #ff4400; padding-left: 4px"> (已选)</span>
            </dd>
          </dl>
          <ul class="item-group">
            <RadioGroup :value="convertIdx" style="width: 100%" @on-change="changeConvertIdx">
              <li v-for="(conv, i) of converteies" :key="i">
                <Radio :label="i" class="item-group-dd">
                  {{ conv.transFromTypeName }}
                </Radio>
                <dd class="item-group-dd dd-child">
                  <span v-if="conv.value">可用</span>
                  <span v-else class="g-error-text">不可用</span>
                </dd>
              </li>
            </RadioGroup>
          </ul>
        </div>
      </div>
    </div>
    <div slot="footer" class="c-convert-footer">
      <Button type="default" @click="$emit('input', false)">返回上一步</Button>
      <Button type="default" v-if="btnRetry" @click="resizeConvert">重试</Button>
      <Button type="primary" :disabled="!Boolean(btnSuccess)" @click="next">确认并下一步</Button>
    </div>
  </Modal>
</template>
<script>
import { getLocal, setLocal, setSession } from '@/common/js/api'
import { isArray, isEmpty, deepCopy } from '@/common/js/utils'
import { getConvertList } from '@/api/baidu.model'
export default {
  name: 'bdconverter',
  props: {
    value: {
      type: Boolean
    },
    accounts: {
      type: Array
    },
    platform: {
      type: Number
    },
    gameId: {
      type: [Number, String]
    },
    checkUrl: {
      type: String
    },
    package: {
      type: String
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    converteies() {
      let convert = []
      if (this.success_d.length) convert = this.success_d.filter((ret) => ret.index === this.current).pop().converter
      return convert
    },
    convertIdx() {
      let idx = ''
      if (this.success_d.length) idx = this.success_d.filter((ret) => ret.index === this.current).pop().convert_idx
      return idx
    }
  },
  data() {
    return {
      show: null, // 请求状态
      current: 0,
      btnSuccess: null, // 成功状态
      btnRetry: null, // 失败状态
      success_d: [] // 表格数据
    }
  },
  methods: {
    bindGetData(val) {
      if (val) this.resizeConvert()
      else {
        // 还原默认值
        this.app_id = null
        this.current = 0
        this.success_d = []
      }
    },
    changeConvertIdx(index) {
      this.$set(this.success_d[this.current], 'convert_idx', index)
    },
    resizeConvert() {
      if (isArray(this.accounts) && this.accounts.length) {
        this.preCheckConvert((data) => {
          if (isArray(data)) {
            // 所有账号
            const success_d = deepCopy(this.accounts).map((ret, index) => {
              ret.index = index
              ret.convert_idx = getLocal('apptrans') ? getLocal('apptrans')[ret.id] : '' // 取本地存储
              ret.converter = data.filter((met) => met.adAccountId === ret.id)
              return ret
            })
            this.btnSuccess = success_d.some((ret) => ret.converter.some((r) => r.value))
            this.btnRetry = data.some((ret) => !ret.value)
            this.success_d = success_d
          } else this.success_d = []
        })
      } else this.$Message.error('未选择账号')
    },
    // 验证账号是否转化
    preCheckConvert(fn) {
      const accounts = this.accounts.map((ret) => ret.id)
      this.show = true
      getConvertList({
        accountIds: accounts,
        platform: this.platform,
        downloadUrl: this.checkUrl,
        apkName: this.package,
        game_id: this.gameId
      }).then((data) => {
        this.show = false
        fn(data)
      })
    },
    next() {
      let index
      // 验证转化没选
      const convertx = this.success_d.some((ret) => {
        index = ret.index
        return isEmpty(ret.convert_idx)
      })
      if (convertx) {
        this.$Message.warning('账号转化追踪不能为空')
        this.current = index
        return
      }
      // 验证转化可用
      const exists = this.success_d.every((ret) => {
        index = ret.index
        const idx = ret.convert_idx
        return !(ret.converter && ret.converter[idx].value)
      })
      // 存在删除账号
      const noAllows = this.success_d
        .filter((ret) => {
          index = ret.index
          const idx = ret.convert_idx
          return !(ret.converter && ret.converter[idx].value)
        })
        .map((ret) => ret.name)
      if (exists) {
        this.$Message.warning('账号转化追踪必须有为“可用”！')
        this.current = index
        return
      }
      if (noAllows.length) {
        const accountNames = noAllows.length > 3 ? noAllows.splice(3) : noAllows
        this.$Modal.confirm({
          title: '系统提示',
          width: 574,
          content: `<p>系统检测到【${accountNames.join(
            '，'
          )}】等账号转化追踪信息为不可用。</p><p>为了流程更高效，系统将放弃转化追踪不可用的账号创建计划，你确定要这样吗？</p>`,
          onOk: () => {
            this.jump()
          }
        })
      } else this.jump()
    },
    jump() {
      // 写入本地存储
      const ac = this.success_d.map((ret) => ret.id)
      const ix = this.success_d.map((ret) => ret.convert_idx)
      const acix = {}
      ac.forEach((ret, i) => {
        acix[ret] = ix[i]
      })
      setLocal('apptrans', acix)
      // 提交转化
      const convertParams = this.success_d.map((ret) => {
        const idx = ret.convert_idx
        return Object.assign({}, ret.converter[idx], {
          platform: this.platform,
          gameId: this.gameId,
          downloadUrl: this.checkUrl,
          apkName: this.package
        })
      })
      setSession('convert_params', convertParams)
      setSession(
        'ad_account_ids',
        this.accounts.filter((ret) =>
          convertParams
            .filter((met) => met.value)
            .map((met) => met.adAccountId)
            .includes(ret.id)
        )
      )
      this.$emit('on-complete')
    }
  }
}
</script>
<style lang="scss" scoped>

.c-convert {
  padding: 20px;
  min-height: 322px;

  .col-item {
    padding-top: 7px;
  }
}

.c-convert-table {
  width: 90%;
  margin: 0 auto;
  border: solid 1px #efefef;

  .c-table-thead {
    margin: 0;
    display: flex;
    height: 30px;
    line-height: 30px;
    border-bottom: solid 1px #efefef;
    background-color: #f8f8f9;

    dt {
      padding-left: 8px;
      color: #333;
      border-left: solid 1px #efefef;

      &:first-child {
        border-width: 0;
      }
    }
  }

  .c-convert-body {
    display: flex;
    max-height: 364px;

    .item-account, .item-group {
      display: inline-block;
    }

    .item-account {
       overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
      width: 40%;
      max-height: 364px;

      dd {
        width: 100%;
        min-height: 40px;
        line-height: 1.2;
        white-space: normal;
        word-break: break-all;
        padding: 6px 0 6px 8px;
        border-bottom: solid 1px #efefef;
        display: flex;
        align-items: center;

        &.on {
          color: #fff;
          background-color: #2b85e4;
        }
      }
    }

    .item-group {
      width: 60%;
      margin: 0;
      border-left: solid 1px #efefef;

      li {
        line-height: 32px;
        border-bottom: solid 1px #efefef;

        &:last-child {
          border-width: 0;
        }
      }

      .item-group-dd {
        margin: 0;
        display: inline-block;
        width: 75%;
        padding-left: 8px;
        border-right: solid 1px #efefef;

        &:last-child {
          border-width: 0;
        }

        &.dd-child {
          width: 25%;

          a {
            margin-right: 6px;
          }
        }
      }
    }
  }
}

.c-convert-footer {
  padding: 0 12px;
  text-align: center;
}

.no-select-data {
  width: 300px;
  font-size: 12px;
  text-align: center;
  padding: 12px 20px;
}

.row-redio-group {
   overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 240px;

  .ivu-radio-wrapper {
    text-align: left;
  }
}

.item-span-info {
  display: inline-block;
  font-size: 12px;
  color: #ff4400;
  margin-top: 8px;
}
</style>
